export default __webpack_public_path__ + "alberta-arrow-right.535348669b2c43f70c2a.svg";